import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Input, Button, Upload } from 'antd';
import { Icon, Modal } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import ApiCaller from '../../utils/api-caller';
import Toast from 'antd-mobile/lib/toast';
import moment from 'moment';
import { Markup } from 'interweave';
import * as SignalR from '@aspnet/signalr';
import LocalStorage from '../../utils/localStorage';
import './print-file.css';

const { Content } = Layout;
const { TextArea } = Input;
const confirmAlert = Modal.alert;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'templateStore',
    'CmsLanguageStore',
    'popupStore',
    'loginStore',
    'printFileStore',
    'webSettingStore',
    'TransactionStore'
)
@observer
class PrintFilePage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        };
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        };

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.printFileStore.getData();
        
        this.props.CmsLanguageStore.getActives().then(() => {
            this.props.templateStore.getActive().then(() => {
                this.props.webSettingStore.getData().then(() => {
                    const { activeTemplate } = this.props.templateStore;
                    const { data: webSettting } = this.props.webSettingStore;

                    if (webSettting) {
                        this.props.popupStore.getByModuleName('PRINT_FILE').then(resp => {
                            if (resp) {
                                if (resp.title) {
                                    confirmAlert(
                                        <div style={{
                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                            color: activeTemplate.templateSetting.label.color,
                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                        }}>
                                            <span>{resp.title}</span>
                                        </div>,
                                        <div style={{
                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                            color: activeTemplate.templateSetting.text.color,
                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 8}px`
                                        }}>
                                            <Markup content={resp.description} />
                                        </div>,
                                        [
                                            {
                                                text: <span style={{
                                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                    color: activeTemplate.templateSetting.label.color,
                                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                }}>OK</span>
                                            }
                                        ]);
                                }
                            }
                        });

                    }
                });
            });
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    back = () => {
        this.props.history.push('/');
    }

    submitClicked = () => {
        this.props.history.push('/');
    }

    dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    handleChange = info => {
        this.props.printFileStore.resetField();
        let fileList = [...info.fileList];

        // 1. Limit the number of uploaded files
        // Only to show two recent uploaded files, and old ones will be replaced by the new
        // fileList = fileList.slice(-2);

        // 2. Read from response and show file link
        fileList = fileList.map(file => {
            if (file.status === 'done') {
                const fileName = `${moment().format('MMDDYYYY_hhmmss')}_${file.name}`;
                ApiCaller.Upload.apiUploadDocument(file.originFileObj, fileName).then(response => {
                })

                file.url = `https://s3-ap-east-1.amazonaws.com/staymenu-images/Documents/${fileName}`;
                this.props.printFileStore.setFileUrl(`https://s3-ap-east-1.amazonaws.com/staymenu-images/Documents/${fileName}`);
            }

            return file;
        });

        this.setState({ fileList });
    };

    confirm = () => {
        this.props.TransactionStore.settransactionLoading(true);
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        };

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            } else {
                const { activeTemplate } = this.props.templateStore;
                
                const {
                    data: webSettting
                } = this.props.webSettingStore;

                const {
                    remark,
                    fileUrls,
                    menu
                } = this.props.printFileStore;

                let orders = [];
                let order = {
                    'taskId': menu.taskId,
                    'menuId': menu.taskId,
                    'scheduleTime': '',
                    'menuQuantity': 1,
                    'remark': '',
                    'urlFiles': fileUrls,
                    'amount': 0
                };

                orders.push(order);

                const request = {
                    'tenantId': LocalStorage.Get('companyId'),
                    'roomNumber': LocalStorage.Get('roomNo'),
                    'guestId': LocalStorage.Get('customerId'),
                    'summaryRemark': remark,
                    'data': orders
                };

                this.props.TransactionStore.create(request).then((resp) => {
                    if (resp.success) {
                        confirmAlert(
                            <div
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                <span>{webSettting.orderPopupTitleText}</span>
                            </div>,
                            <div
                                style={{
                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                    color: activeTemplate.templateSetting.text.color,
                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
                                    textAlign: 'center'
                                }}
                            >
                                <span>{webSettting.orderPopupSuccessText}</span>
                            </div>,
                            [
                                {
                                    text:
                                        <span
                                            style={{
                                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                color: activeTemplate.templateSetting.label.color,
                                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                            }}
                                        >
                                            {webSettting.backToHomeText}
                                        </span>,
                                    onPress: () => {
                                        this.props.history.push('/');
                                    }
                                },
                                {
                                    text:
                                        <span
                                            style={{
                                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                color: activeTemplate.templateSetting.label.color,
                                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                            }}
                                        >
                                            {webSettting.goToOrderText}
                                        </span>,
                                    onPress: () => {
                                        this.props.history.push('/order');
                                    }
                                }
                            ]);
                    } else {
                        confirmAlert(
                            <div
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                <span>Error</span>
                            </div>,
                            <div
                                style={{
                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                    color: activeTemplate.templateSetting.text.color,
                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
                                    textAlign: 'center'
                                }}
                            >
                                <span>{webSettting.orderPopupFailedText}</span>
                            </div>,
                            [
                                {
                                    text:
                                        <span
                                            style={{
                                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                color: activeTemplate.templateSetting.label.color,
                                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                            }}
                                        >
                                            OK
                                        </span>
                                }
                            ]);
                    }
                });
            }
        });
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const {
            menu
        } = this.props.printFileStore;

        const { remark } = this.props.printFileStore;

        const props = {
            customRequest: this.dummyRequest,
            onChange: this.handleChange,
            multiple: true,
        };

        const { transactionLoading } = this.props.TransactionStore;

        if (webSettting) {
            if (transactionLoading) {
                Toast.loading(<span style={{
                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                    fontSize: activeTemplate.templateSetting.text.fontSize,
                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                }}>{webSettting.processingOrderLoadingText}</span>, 100, null, true);
            } else {
                Toast.hide();
            }
        }

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            <Layout className='stm-width-100-percent stm-height-100-percent stm-max-width-500 stm-background-white stm-margin-0-auto'>
                                {
                                    webSettting
                                        ?
                                        <Content>
                                            {/* Header */}
                                            <>
                                                <Row>
                                                    <Col
                                                        span={24}
                                                        className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                                        style={{
                                                            fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                            background: activeTemplate.templateSetting.header.backgroundColor,
                                                            color: activeTemplate.templateSetting.header.color,
                                                            fontSize: activeTemplate.templateSetting.header.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col span={4} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50' onClick={this.back}>
                                                                <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                                            </Col>
                                                            <Col span={16} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'>
                                                                {menu ? menu.taskName : ''}
                                                            </Col>
                                                            <Col span={4} />
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Banner */}
                                            <>
                                                {
                                                    menu
                                                        ?
                                                        <>
                                                            {
                                                                menu.bannerUrl === null || menu.bannerUrl === ''
                                                                    ?
                                                                    <Row className='stm-margin-top-50' />
                                                                    :
                                                                    <>
                                                                        <Row className='stm-height-160 stm-margin-top-50 stm-background-size-100-percent'>
                                                                            <Col span={24} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-160'>
                                                                                <img src={menu.bannerUrl} alt='Icon' />
                                                                            </Col>
                                                                        </Row>
                                                                    </>
                                                            }
                                                        </>
                                                        :
                                                        null
                                                }
                                            </>

                                            {/* Body */}
                                            <Row className='row-body-content'>
                                                <Col span={1} />
                                                <Col span={22}>
                                                    {/* Task Description */}
                                                    <>
                                                        {
                                                            menu
                                                                ?
                                                                <>
                                                                    {
                                                                        menu.taskDesc !== ''
                                                                            ?
                                                                            <Row className='stm-tab-description-container'>
                                                                                <Col span={24} className='stm-tab-description'>
                                                                                    <Row>
                                                                                        <Col span={3} className='stm-tab-description-image'>
                                                                                            <img src={require('../../assets/image/Icon/HelpInfo.svg')} alt='HelpInfo' className='stm-item-desc-image' />
                                                                                        </Col>
                                                                                        <Col
                                                                                            span={21}
                                                                                            className='stm-tab-description-text'
                                                                                            style={{
                                                                                                fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                fontSize: activeTemplate.templateSetting.buttonItem.fontSize - 2,
                                                                                                lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize}px`,
                                                                                                color: activeTemplate.templateSetting.buttonItem.color
                                                                                            }}
                                                                                        >
                                                                                            <Markup content={menu.taskDesc} />
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Col>
                                                                            </Row>
                                                                            :
                                                                            null
                                                                    }
                                                                </>
                                                                :
                                                                null
                                                        }
                                                    </>

                                                    <Upload {...props} fileList={this.state.fileList}>
                                                        <Col
                                                            span={24}
                                                            className='col-uploadbutton'
                                                            onClick={this.makeUpRoomClicked} hidden={this.state.makeUpRoomSelected}
                                                            style={{
                                                                fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                                color: activeTemplate.templateSetting.buttonItem.color,
                                                                border: `1px solid ${activeTemplate.templateSetting.buttonItem.borderColor}`,
                                                                backgroundColor: activeTemplate.templateSetting.buttonItem.backgroundColor
                                                            }}
                                                        >
                                                            Upload File(s)
                                                        </Col>
                                                    </Upload>
                                                </Col>
                                                <Col span={1} />
                                            </Row>

                                            {/* Footer */}
                                            <Row>
                                                <Col span={24} className='stm-position-fixed stm-bottom-0 stm-padding-bottom-15 stm-background-white stm-padding-top-15 stm-max-width-500'>
                                                    {/* Remark */}
                                                    <Row>
                                                        <Col span={1} />
                                                        <Col span={22} className='pd-t-10'>
                                                            <TextArea value={remark} onChange={(e) => this.props.printFileStore.setRemark(e.target.value)} placeholder={webSettting.remarkText} />
                                                        </Col>
                                                        <Col span={1} />
                                                    </Row>
                                                    <br />
                                                    {/* Confirm */}
                                                    <Row>
                                                        <Col span={1} />
                                                        <Col span={22} >
                                                            <Button
                                                                className={this.state.fileList ? 'stm-width-100-percent stm-border-radius-4 stm-height-54 stm-margin-bottom-2' : 'stm-width-100-percent stm-border-radius-4 stm-height-54 stm-margin-bottom-2 stm-opacity-60'}
                                                                onClick={this.state.fileList ? this.confirm : null}
                                                                style={{
                                                                    background: activeTemplate.templateSetting.buttonFooter.backgroundColor,
                                                                    fontFamily: activeTemplate.templateSetting.buttonFooter.fontFamily,
                                                                    fontSize: activeTemplate.templateSetting.buttonFooter.fontSize,
                                                                    lineHeight: `${activeTemplate.templateSetting.buttonFooter.fontSize + 2}px`,
                                                                    color: activeTemplate.templateSetting.buttonFooter.color
                                                                }}
                                                            >
                                                                {webSettting.confirmText}
                                                            </Button>
                                                        </Col>
                                                        <Col span={1} />
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Content>
                                        :
                                        null
                                }
                            </Layout>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(PrintFilePage)